import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import EmailDetails from './form/EmailDetails.js';
import Notification from '../../components/Notification.js';
import GeneralHandler from '../../modules/General';
import {setSetting} from '../../actions/General.js';
import ColorPicker from '../../components/builder/ColorPicker.js';

import Dropzone from 'react-dropzone';
import LoadingSmall from '../../components/LoadingSmall';

class SettingsCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isUploading:false,
            isUploadLarge:false,
            isLoading:true,
            isSavingPUSH_PRIMARY_COLOR:false,
            isSavingSUBDOMAIN:false,
            isSubdomainSet:false,
        }
        this.updateKey = this.updateKey.bind(this);

        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);


        this.onDrop = this.onDrop.bind(this);
        this.onOpenClick = this.onOpenClick.bind(this);
        this.handleImageReset = this.handleImageReset.bind(this);


        this.onDropLarge = this.onDropLarge.bind(this);
        this.onOpenClickLarge = this.onOpenClickLarge.bind(this);
        this.handleImageResetLarge = this.handleImageResetLarge.bind(this);
    }

    handleImageReset() {
        let data = {
            'LOGO_64x64':'',
        };

        axios.put('/settings',data);
        this.props.setSetting('LOGO_64x64','');

    }

    handleImageResetLarge() {
        let data = {
            'LOGO_300x200':'',
        };

        axios.put('/settings',data);
        this.props.setSetting('LOGO_300x200','');

    }

    onDrop(files) {
        if(files.length == 0) {
            return;
        }

        this.setState({isUploading:true});

        let data = new FormData();
        data.append('file', files[0]);
        data.set('key','LOGO_64x64');
        data.set('resize_max','1');
        data.set('resize_min','1');

        axios.post('/settings/upload',data)
            .then(res => {
                this.setState({isUploading:false});
                this.props.setSetting('LOGO_64x64',res.data.value)
            }).catch(err => {
            this.setState({isUploading:false});
        });
    }

    onDropLarge(files) {
        if(files.length == 0) {
            return;
        }

        this.setState({isUploadingLarge:true});

        let data = new FormData();
        data.append('file', files[0]);
        data.set('key','LOGO_300x200');
        data.set('resize_max','1');

        axios.post('/settings/upload',data)
            .then(res => {
                this.setState({isUploadingLarge:false});
                this.props.setSetting('LOGO_300x200',res.data.value)
            }).catch(err => {
            this.setState({isUploadingLarge:false});
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }

    onOpenClickLarge() {
        this.refs.dropzoneLarge.open();
    }

    handleColorChange(key,value) {
        this.props.setSetting(key,value);
    }

    handleInputChange(e) {
        let subdomain = e.target.value;
        this.props.setSetting('SUBDOMAIN',subdomain);
    }

    updateKey(key) {
        let state = {
            ['isSaving'+key]:true
        };

        if(key == 'SUBDOMAIN') {
            let subdomain = this.props.general.settings[key];
            if(subdomain.length < 3) {
                Notification.error('Subdomain must contain more than two characters');
                return;
            }

            let reg = new RegExp(/[^0-9-A-z]/g);

            if(reg.test(subdomain)) {
                Notification.error('Subdomain can only contain A-Z and 0-9');
                return;
            }

            state.isSubdomainSet = true;


        }

        this.setState(state);

        let data = {
            [key]:this.props.general.settings[key],
        };

        axios.put('/settings',data).then(res => {
            this.setState({
                ['isSaving'+key]:false
            });

            Notification.success('Success!');
        }).catch(err => {
            this.setState({
                ['isSaving'+key]:false
            });
        });
    }

    componentWillMount() {
        GeneralHandler.fetchGeneral().then(() => {
            let subdomain = false;

            if(this.props.general.settings.SUBDOMAIN != '' && this.props.general.settings.SUBDOMAIN != null && this.props.general.settings.SUBDOMAIN !== false) {
                subdomain = true;
            }

            this.setState({isLoading:false,isSubdomainSet:subdomain});


        });


    }

    render() {

        if(this.state.isLoading) {
            return <Loading error={false} />
        }

        return (
            <div className="full-height">
                <Helmet title="Company | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-briefcase"></i> Company</span>
                </div>

                <div className="page-content">


                    <OptionColumn title="Color" description="What is your primary and off-color?">
                        <h6>Primary</h6>
                        <ColorPicker id='PRIMARY_COLOR' color={this.props.general.settings.PRIMARY_COLOR} handleColorChange={this.handleColorChange} />

                        <h6>Off-color</h6>
                        <ColorPicker id='SECONDARY_COLOR' color={this.props.general.settings.SECONDARY_COLOR} handleColorChange={this.handleColorChange} />
                        <br />
                        {
                            this.state.isSavingPRIMARY_COLOR
                                ?
                                <LoadingSmall />
                                :
                                <button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.updateKey('SECONDARY_COLOR'); this.updateKey('PRIMARY_COLOR')}}>Update</button>
                        }
                    </OptionColumn>

                    <SplitRows />

                    <OptionColumn title="Large logo" description="Upload a large logo. Max image size is 300px X 200px">
                        <div className="col-sm-6 text-center">
                            <img src={this.props.general.settings.LOGO_300x200} style={{maxWidth:'300px'}} />

                        </div>
                        <div className="col-sm-6">
                            <br />
                            <br />
                            <Dropzone ref="dropzoneLarge" style={{}} disableClick={true} multiple={false} onDrop={this.onDropLarge}>
                                {
                                    this.state.isUploadLarge ?
                                        <LoadingSmall />
                                        :
                                        <button type="button" onClick={this.onOpenClickLarge} className="btn btn-dark btn-block">Upload logo</button>
                                }
                            </Dropzone>
                            <br />
                            <button className="btn btn-dark btn-block" onClick={this.handleImageResetLarge}>Reset logo</button>

                        </div>
                    </OptionColumn>




                    <SplitRows />



                    <OptionColumn title="Small logo" description="Upload a small logo. It MUST be 64px X 64px">
                        <div className="col-sm-6 text-center">
                            <img src={this.props.general.settings.LOGO_64x64} style={{width:'64px'}} />

                        </div>
                        <div className="col-sm-6">
                            <br />
                            <br />
                            <Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
                                {
                                    this.state.isUploading ?
                                        <LoadingSmall />
                                        :
                                        <button type="button" onClick={this.onOpenClick} className="btn btn-dark btn-block">Upload logo</button>
                                }
                            </Dropzone>
                            <br />
                            <button className="btn btn-dark btn-block" onClick={this.handleImageReset}>Reset logo</button>

                        </div>
                    </OptionColumn>




                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSetting},dispatch)
}


SettingsCompany = connect(mapStateToProps,mapDispatchToProps)(SettingsCompany);
export default SettingsCompany;



// WEBPACK FOOTER //
// ./containers/settings/SettingsCompany.js